import { useAuth } from "@providers/auth";
import { FC, PropsWithChildren } from "react";

export const SubscriptionGuard : FC<PropsWithChildren<{}>> = ({ children}) => {
    const auth = useAuth();
    const location = window.location;
    const stripe_expire = auth?.user?.["https://core-backend.fence-estimator/app_metadata"]?.stripe_subscription_expire;
    if(stripe_expire && ( new Date(stripe_expire).getTime() + 24*60*60*1000 ) < new Date().getTime() && !location.pathname.includes("profile") && !location.pathname.includes("admin")){
        window.location.href = "/admin/users?error=subscription_expired";
    }
    return<>{children}</>
}